import Cookies from 'js-cookie'

// Cookies share a host across ports; each deployment must own its login token.
// Do not adopt the legacy shared cookie: it may belong to another application.
const TokenKey = `shandobakoAlgo.loginToken.${window.location.protocol.slice(0, -1)}.${window.location.port || 'default'}`
const CookieOptions = { path: '/', sameSite: 'Lax', secure: window.location.protocol === 'https:' }

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, CookieOptions)
}

export function removeToken() {
  return Cookies.remove(TokenKey, CookieOptions)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js